import styles from "./home.module.css";
import SwiperCore, { Autoplay } from "swiper";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import imgXRH from "../../assets/images/52.svg";
import imgDash from "../../assets/images/131.svg";
import imgEtr from "../../assets/images/1027.svg";
import imgBch from "../../assets/images/bitcoin.svg";
function HotCrypt({ data }) {
  SwiperCore.use([Navigation, Autoplay]);
  let Iloop;
  if (data > 4) {
    Iloop = true;
  } else Iloop = false;
  return (
    <div
      className={`mt-4 mb-5 text-center hot-crypt-container ${styles.hotest}`}
    >
      <div
        className={`   justify-content-evenly m-auto  ${styles.widthHotest}`}
      >
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          loop={true}
          observer={true}
          observeParents={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay={{
            delay: 3000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // when window width is >= 320px

            400: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 535px
            429: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            // when window width is >= 992px
            992: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
          key={Math.random() * 50}
        >
          {data.map((value) => {
            return (
              <SwiperSlide
                className={`d-flex flex-column  justify-content-evenly align-items-center text-light ${styles.cryptCard} `}
                style={{ backgroundColor: value.bgColor }}
              >
                <img
                  className={styles.xhrIcon}
                  src={value.image}
                  style={{ backgroundColor: "white" }}
                />
                {value.informationJSX}
              </SwiperSlide>
            );
          })}
          {window.innerWidth >= 900 ? (
            <>
              <div class="swiper-button-prev" style={{ color: "white" }}></div>
              <div class="swiper-button-next" style={{ color: "white" }}></div>
            </>
          ) : (
            ""
          )}
        </Swiper>
      </div>
    </div>
  );
}

export default HotCrypt;
